import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/modules/mousewheel/mousewheel.scss';

document.addEventListener('DOMContentLoaded',function() {
    
    const carousel = document.querySelectorAll('.js-carousel'),
          benefits = document.querySelector('.js-benefits');

    const benefits_init = () => {                
	    const swiper = new Swiper(benefits, {
    	    modules: [Navigation, Pagination],
    	    centeredSlides: true,
            loop: true,
            breakpoints: {
                769: {
                    centeredSlides: false,
                    slidesPerGroup: 4,
                    slidesPerView: 4,
                    spaceBetween: 0
                }
            },
            navigation: {
                nextEl: benefits.parentNode.querySelector('.swiper-button-next'),
                prevEl: benefits.parentNode.querySelector('.swiper-button-prev')
            },
            pagination: {
                el: '.swiper-pagination',
                    clickable: true
            },
            slidesPerView: 'auto',
            spaceBetween: 16,
            speed: 500
        });       
    };
    
    const carousel_init = () => {
        let swiper = [];
        let mediaQuery = '(max-width: 768px)',
            mediaQueryList = window.matchMedia(mediaQuery);
                
        const start = ()=> {
            for (let i = 0; i < carousel.length; i++) {
        	    swiper[i] = new Swiper(carousel[i], {
            	    modules: [Pagination],
                    centeredSlides: true,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                            clickable: true
                    },
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    speed: 500
                });
            }
        }
        
        const destroy = () => {
            for (let i = 0; i < swiper.length; i++) {
        	    swiper[i].destroy(true, true);
            }
        }
        
        mediaQueryList.addEventListener('change', event => {
            event.matches ? start() : destroy();
        })

        mediaQueryList.matches ? start() : false;        
    };

    window.carousels = function() {
        benefits ? benefits_init() : false;
        carousel.length > 0 ? carousel_init() : false;
    }

}, false)
